import { useEffect } from 'react'

import { scrollToPageHash, syncPageHash } from '@/lib/scroll-to-page-hash'

function landingPath(pathname: string) {
  const path = pathname.replace(/\/+$/, '') || '/'
  return path === '/' || path === '/contact'
}

function samePageHashHref(href: string) {
  let url: URL
  try {
    url = new URL(href, window.location.origin)
  } catch {
    return ''
  }
  if (url.origin !== window.location.origin || !url.hash) return ''
  const current = window.location.pathname.replace(/\/+$/, '') || '/'
  const next = url.pathname.replace(/\/+$/, '') || '/'
  if (current !== next && !(landingPath(current) && landingPath(next))) {
    return ''
  }
  return url.hash
}

/** Same-page hash clicks, load, and history so anchors share one scroll helper. */
export function PageHashNavigation() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return
      }
      const target = event.target
      if (!(target instanceof Element)) return
      const anchor = target.closest('a')
      if (!anchor?.href) return
      const hash = samePageHashHref(anchor.href)
      if (!hash || hash === '#top') return
      event.preventDefault()
      scrollToPageHash(anchor.href)
      syncPageHash(anchor.href)
    }

    const onHashRoute = () => {
      const hash = window.location.hash
      if (!hash) return
      scrollToPageHash(hash)
    }

    document.addEventListener('click', onClick)
    window.addEventListener('hashchange', onHashRoute)
    window.addEventListener('popstate', onHashRoute)
    onHashRoute()

    return () => {
      document.removeEventListener('click', onClick)
      window.removeEventListener('hashchange', onHashRoute)
      window.removeEventListener('popstate', onHashRoute)
    }
  }, [])

  return null
}
